import { render, staticRenderFns } from "./DatabaseBackup.vue?vue&type=template&id=775b9fa6&"
import script from "./DatabaseBackup.vue?vue&type=script&lang=js&"
export * from "./DatabaseBackup.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseBackup.vue?vue&type=style&index=0&id=775b9fa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports